<template>
  <div class="container-custom">
    <v-form ref="form" @submit.prevent="saveHandler">
      <Breadscrumbs
        :links="[
          {
            name: 'VideoCateCenter',
            to: {
              name: 'VideoCateCenter'
            }
          },
          {
            name: 'Edit',
            to: {
              name: 'VideoCateEdit',
              params: {
                id: $route.params.id
              }
            }
          }
        ]"
      ></Breadscrumbs>
      <!-- page-actions -->
      <div class="page-actions">
        <h2>修改分類</h2>
        <v-spacer></v-spacer>
        <button class="btn mr-5" @click="cancelHandler">
          <span>取消</span>
        </button>
        <button class="btn btn-primary" type='submit'>
          <span>儲存</span>
        </button>
      </div>
    </v-form>
    <!-- Block 類別 -->
    <VideoCategoryCreateEdit></VideoCategoryCreateEdit>
    <LangDialog :isOpen.sync="isLangOpen" @confirm-submit="saveHandler()"></LangDialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import VideoCategoryCreateEdit from '@/views/E-6__SupportVideos/c/VideoCateCreateEdit.vue';
import LangDialog from '@/components/LangSubmitDialog.vue';

export default {
  components: {
    Breadscrumbs,
    VideoCategoryCreateEdit,
    LangDialog,
  },
  data: () => ({
    isLangOpen: false,
  }),
  computed: {
    ...mapState(['lang']),
    ...mapState('videocate', ['videocate']),
  },
  async created() {
    if (this.$route.params.id) {
      await this.getVideoCategory(this.$route.params.id);
    }
  },
  methods: {
    ...mapActions('videocate', {
      getVideoCategory: 'findById',
      save: 'save',
    }),
    cancelHandler() {
      this.$router.push({ name: 'VideoCateCenter' });
    },
    saveHandler() {
      if (this.isLangOpen || !this.lang.id) {
        this.errors = [];
        if (this.$refs.form.validate()) {
          if (!this.videocate.title) {
            this.errors.push('標題 required.');
          } else if (!this.videocate.bu_id) {
            this.errors.push('BU required.');
          } else if (!this.videocate.support_categories_id) {
            this.errors.push('類別 required.');
          }
          if (this.errors.length > 0) {
            /* eslint-disable */
            alert(this.errors);
            /* eslint-disable */
            return false;
          }
          this.save(this.videocate).then(() => {
            this.$router.push({ name: 'VideoCateCenter' });
          });
        }
      } else {
        this.isLangOpen = true;
      }
    },
  },
};
</script>

<style></style>
